const utils = require("./utils")
export function getTasksWithChangedGUID(tasks) {
    const copiedTasks = []
    if (tasks && tasks.length > 0) {
        tasks.forEach((task) => {
            const copiedTask = Object.assign({}, task)
            copiedTask.Id = utils.guid()
            copiedTasks.push(copiedTask)
        })
    }
    return copiedTasks
}
